import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { TheHeader } from "@maropost-ui/liquidsky-ui"
  import { AppConfig } from "@/lib/config"
  import { computed, onMounted, nextTick, ref, watch } from "vue"
  import { useUserStore } from "@/lib/stores"
  import AccountsDropDown from "./AccountsDropDown.vue"
  import UserDropDown from "./UserDropDown.vue"
  import SearchBar from "./SearchBar.vue"
  import { DrawerHost } from "@/lib/composable/drawer/drawerHostSDK"
  import { GuideCTA } from "@/lib/components"

// @ts-ignore
  import maropostLogo from "@/assets/maropost-logo.svg"
  import NotificationsDrawer from "../drawers/NotificationsDrawer.vue"
  import { useNotificationService } from "@/lib/services"

  // --------------------------------------------------
  // Store + Services
  // --------------------------------------------------
  
export default /*@__PURE__*/_defineComponent({
  __name: 'TheHeader',
  setup(__props) {

  const userStore = useUserStore()
  const unreadCount = ref(0)

  /**
   * Handler for update_unread_count event from NotificationsDrawer
   */
  const handleUpdateUnreadCount = (count: number): void => {
    unreadCount.value = count
  }

  /**
   * Hide notification icon if user does not have access to marketing or commerce
   */

  const hideNotificationIcon = computed(() => {
  if (!userStore.getAccountId) return true;

  const hasMarketingAccess =
    userStore.getProductAccess("marketing") &&
    userStore.getProductAccessOnRoles("marketing");

  const hasCommerceAccess =
    userStore.getProductAccess("commerce") &&
    userStore.getProductAccessOnRoles("commerce");

  return !hasMarketingAccess && !hasCommerceAccess;
});

  /**
   * Notifications
  */
  const notificationList = computed(() => useNotificationService.notifications?.value ?? [])
  /**
   * Get the drawer component instance
   */
  const getDrawerComponentInstance = async (): Promise<any> => {
    return new Promise<any>((resolve) => {
      DrawerHost.onReady(async (api) => {
        await nextTick()
        resolve(api.getComponentInstance())
      })
    })
  }

  /**
   * Function to open the notification drawer.
  */
  const openNotificationDrawer = async (): Promise<void> => {
    /**
     * Open the notification drawer and pass the notification list to the drawer
     */
    DrawerHost.open({
      component: "NotificationsDrawer",
      options: {
        width: 570,
      },
      props: {
        notificationList: notificationList.value,
        onUpdateUnreadCount: handleUpdateUnreadCount
      },
      onClose: async () => {
        const componentInstance = await getDrawerComponentInstance()
        if (componentInstance?.unmount) {
          await componentInstance.unmount()
        }
      }
    })

    // Call mount method on the NotificationsDrawer component
    const componentInstance = await getDrawerComponentInstance()
    if (componentInstance?.mount) {
      await componentInstance.mount()
    }
  }

  /**
   * Watch useNotificationService.meta and update the unread count when it changes
   */
  watch(() => useNotificationService.meta?.value, (newVal: Record<string, unknown> | undefined) => {
    handleUpdateUnreadCount((newVal?.unread_count as number) ?? 0)
  }, { immediate: true })

  onMounted(async () => {
    /**
     * Handle update unread count for global access
     * This is done to ensure the unread count is updated in the header when the notification drawer is opened
     * from the remote application
     */
    (window as any).handleUpdateUnreadCount = (count: number): void => {
      handleUpdateUnreadCount(count)
    }

    /**
     * onReady: Register NotificationDrawer with DrawerHost
     * This is done to ensure the NotificationDrawer is registered with DrawerHost when the component is mounted
     */
    DrawerHost.onReady((api) => {
      api.register('NotificationsDrawer', NotificationsDrawer)
    })
  })


return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createBlock(_unref(TheHeader), {
    "notification-icon-props": {
      onClick: openNotificationDrawer,
      count:unreadCount.value ?? 0,
      hideNotificationIcon: hideNotificationIcon.value
    },
    timezone: _unref(userStore).auth.preference.time_zone,
    "route-to-preferences": `${_unref(AppConfig).IDENTITY_BASE_URL}/#/preferences`,
    username: _unref(userStore).username,
    hideAppBarNavIcon: "",
    logout: _unref(userStore).logout,
    "account-id": _unref(userStore).getAccountId
  }, _createSlots({
    "apps-dropdown": _withCtx(() => [
      _createVNode(_component_v_img, {
        class: "mx-8 mr-14",
        width: "120px",
        src: _unref(maropostLogo),
        alt: "Maropost logo"
      }, null, 8, ["src"])
    ]),
    "user-dropdown": _withCtx(() => [
      _createVNode(UserDropDown)
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(GuideCTA))
    ]),
    _: 2
  }, [
    (_unref(userStore).getAccountId)
      ? {
          name: "account-dropdown",
          fn: _withCtx(() => [
            _createVNode(AccountsDropDown)
          ]),
          key: "0"
        }
      : undefined,
    (_unref(userStore).getAccountId)
      ? {
          name: "search-bar",
          fn: _withCtx(() => [
            _createVNode(SearchBar)
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["notification-icon-props", "timezone", "route-to-preferences", "username", "logout", "account-id"]))
}
}

})